module.exports = __webpack_public_path__ + "static/52-68424a97c1835d1c75444c770898c0ac.jpg";